import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  FormControlLabel,
  Radio,
  Typography,
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const PaymentOptions = ({
  handleInputChangePaymentMethod,
  selectedPaymentMethod,
  t,
}) => {
  const handleChange = (value) => {
    handleInputChangePaymentMethod(value);
  };

  return (
    <div>
      <Accordion
        expanded={selectedPaymentMethod === 2}
        onChange={() => handleChange(2)}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          className="payment-methods-title"
        >
          <FormControlLabel
            className="payment-methods-title-h5"
            value="2"
            control={
              <Radio
                checked={selectedPaymentMethod === 2}
                onChange={() => handleChange(2)}
              />
            }
            label={t("payment_page.form.payment_method.method_2.title")}
          />
        </AccordionSummary>
        <AccordionDetails className="payment-methods-accordion-detail">
          <Typography>
            <div className="payment-methods-description">
              {t("payment_page.form.payment_method.method_2.desc")}
            </div>
          </Typography>
        </AccordionDetails>
      </Accordion>

      <Accordion
        expanded={selectedPaymentMethod === 1}
        onChange={() => handleChange(1)}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          className="payment-methods-title"
        >
          <FormControlLabel
            className="payment-methods-title-h5"
            value="1"
            control={
              <Radio
                checked={selectedPaymentMethod === 1}
                onChange={() => handleChange(1)}
              />
            }
            label={t("payment_page.form.payment_method.method_1.title")}
          />
        </AccordionSummary>
        <AccordionDetails className="payment-methods-accordion-detail">
          <Typography>
            <div className="payment-methods-description">
              {t("payment_page.form.payment_method.method_1.desc")}
            </div>
          </Typography>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default PaymentOptions;
